import React, { FC, useRef, useState } from "react";

import ShareController from "@/components/ShareComponent/ShareController";
import SharePopup from "@/components/ShareComponent/SharePopup";
import { useOutsideClick } from "@/hooks/useOutsideClick";

interface ShareProps {
  children: React.ReactNode;
  shareData: ShareData;
  onSuccess?: () => void;
  onError?: (error?: unknown) => void;
  onInteraction?: () => void;
  disabled?: boolean;
}

const Share: FC<ShareProps> = ({ children, shareData, onInteraction, onSuccess, onError, disabled }) => {
  const [openPopup, setOpenPopup] = useState(false);
  const panelReference = useRef<HTMLDivElement>(null);

  const handleNonNativeShare = () => {
    setOpenPopup(true);
  };

  useOutsideClick(panelReference, () => {
    setOpenPopup(false);
  });

  return (
    <>
      <ShareController
        shareData={shareData}
        onInteraction={onInteraction}
        onSuccess={onSuccess}
        onError={onError}
        onNonNativeShare={handleNonNativeShare}
        disabled={disabled}
      >
        {children}
      </ShareController>
      {openPopup ? (
        <div ref={panelReference} className="mx-auto absolute top-xl left-0 right-0 w-fit">
          <SharePopup shareData={shareData} onClose={() => setOpenPopup(false)} />
        </div>
      ) : null}
    </>
  );
};

export default Share;
